(function () {
  var DEFAULT_COVERAGE = 1.44;
  var DEFAULT_BOX_PRICE = 48;
  var MAX_BOXES = 24;

  function parseNum(val) {
    if (val == null || val === '') return NaN;
    return parseFloat(String(val).replace(',', '.'));
  }

  function money(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  function roundPerM2Cents(boxPriceCents, coverage) {
    var cov100 = Math.round(coverage * 100);
    if (!cov100) return 0;
    var raw = Math.floor((boxPriceCents * 100) / cov100);
    return Math.round(raw / 100) * 100;
  }

  function buildMarkup() {
    return [
      '<div class="tt-area-guide" data-tt-area-guide-root>',
      '  <div class="tt-area-guide__controls">',
      '    <label class="tt-area-guide__field">',
      '      <span class="tt-area-guide__label">Room size (m²)</span>',
      '      <input type="text" inputmode="decimal" class="tt-area-guide__input" data-tt-ag-m2 value="8" autocomplete="off">',
      '    </label>',
      '    <label class="tt-area-guide__field">',
      '      <span class="tt-area-guide__label">Coverage per box (m²)</span>',
      '      <input type="text" inputmode="decimal" class="tt-area-guide__input" data-tt-ag-coverage value="1.44" autocomplete="off">',
      '    </label>',
      '    <label class="tt-area-guide__field">',
      '      <span class="tt-area-guide__label">Box price (£)</span>',
      '      <input type="text" inputmode="decimal" class="tt-area-guide__input" data-tt-ag-price value="48" autocomplete="off">',
      '    </label>',
      '    <label class="tt-area-guide__check">',
      '      <input type="checkbox" data-tt-ag-wastage checked>',
      '      <span>Add 10% for cuts &amp; wastage</span>',
      '    </label>',
      '  </div>',
      '  <div class="tt-area-guide__summary" aria-live="polite">',
      '    <p class="tt-area-guide__result"><strong data-tt-ag-boxes>6 boxes</strong> covering <strong data-tt-ag-area>8.64</strong> m²</p>',
      '    <p class="tt-area-guide__meta">Needed: <span data-tt-ag-needed>8.80</span> m² · About <span data-tt-ag-per-m2>£33</span>/m² · Total <span data-tt-ag-total">£288.00</span></p>',
      '  </div>',
      '  <div class="tt-area-guide__stage" data-tt-ag-stage aria-hidden="true"></div>',
      '  <p class="tt-area-guide__hint">Each box below is one full carton. Tiles fill the boxes to show coverage; leftovers stay empty because you always buy whole boxes.</p>',
      '</div>'
    ].join('\n');
  }

  function tileCountForBox(coverage) {
    if (coverage >= 1.8) return 4;
    if (coverage >= 1.2) return 6;
    if (coverage >= 0.7) return 8;
    return 9;
  }

  function renderBoxes(stage, boxes, coverage, needed) {
    stage.innerHTML = '';
    var show = Math.min(Math.max(boxes, 0), MAX_BOXES);
    var tilesPerBox = tileCountForBox(coverage);
    var covered = 0;

    for (var i = 0; i < show; i++) {
      var box = document.createElement('div');
      box.className = 'tt-area-guide__box';
      box.style.setProperty('--tt-ag-delay', (i * 45) + 'ms');

      var grid = document.createElement('div');
      grid.className = 'tt-area-guide__tiles';
      grid.style.setProperty('--tt-ag-cols', String(Math.ceil(Math.sqrt(tilesPerBox))));

      var boxStart = covered;
      covered += coverage;
      var fillRatio = 1;

      if (needed > 0) {
        if (boxStart >= needed) {
          fillRatio = 0;
        } else if (boxStart + coverage > needed) {
          fillRatio = Math.max(0.15, (needed - boxStart) / coverage);
        }
      }

      var filledTiles = Math.round(tilesPerBox * fillRatio);
      for (var t = 0; t < tilesPerBox; t++) {
        var tile = document.createElement('span');
        tile.className = 'tt-area-guide__tile' + (t < filledTiles ? ' is-filled' : '');
        tile.style.setProperty('--tt-ag-tile-delay', (i * 45 + t * 18) + 'ms');
        grid.appendChild(tile);
      }

      var label = document.createElement('span');
      label.className = 'tt-area-guide__box-label';
      label.textContent = 'Box ' + (i + 1);

      box.appendChild(grid);
      box.appendChild(label);
      stage.appendChild(box);
    }

    if (boxes > MAX_BOXES) {
      var more = document.createElement('p');
      more.className = 'tt-area-guide__more';
      more.textContent = '+' + (boxes - MAX_BOXES) + ' more boxes (not shown)';
      stage.appendChild(more);
    }
  }

  function initGuide(mount) {
    if (mount.dataset.ttAreaGuideReady === 'true') return;
    mount.dataset.ttAreaGuideReady = 'true';
    mount.innerHTML = buildMarkup();

    var root = mount.querySelector('[data-tt-area-guide-root]');
    var m2Input = root.querySelector('[data-tt-ag-m2]');
    var coverageInput = root.querySelector('[data-tt-ag-coverage]');
    var priceInput = root.querySelector('[data-tt-ag-price]');
    var wastageCheck = root.querySelector('[data-tt-ag-wastage]');
    var boxesEl = root.querySelector('[data-tt-ag-boxes]');
    var areaEl = root.querySelector('[data-tt-ag-area]');
    var neededEl = root.querySelector('[data-tt-ag-needed]');
    var perM2El = root.querySelector('[data-tt-ag-per-m2]');
    var totalEl = root.querySelector('[data-tt-ag-total]');
    var stage = root.querySelector('[data-tt-ag-stage]');

    function update() {
      var m2 = parseNum(m2Input.value);
      var coverage = parseNum(coverageInput.value);
      var boxPounds = parseNum(priceInput.value);

      if (!m2 || m2 <= 0) m2 = DEFAULT_COVERAGE;
      if (!coverage || coverage <= 0) coverage = DEFAULT_COVERAGE;
      if (!boxPounds || boxPounds <= 0) boxPounds = DEFAULT_BOX_PRICE;

      var needed = wastageCheck.checked ? m2 * 1.1 : m2;
      var boxes = Math.ceil(needed / coverage);
      if (boxes < 1) boxes = 1;
      var actualArea = boxes * coverage;
      var boxCents = Math.round(boxPounds * 100);
      var perM2 = roundPerM2Cents(boxCents, coverage);
      var total = boxes * boxCents;

      boxesEl.textContent = boxes + (boxes === 1 ? ' box' : ' boxes');
      areaEl.textContent = actualArea.toFixed(2);
      neededEl.textContent = needed.toFixed(2);
      perM2El.textContent = money(perM2).replace('.00', '');
      totalEl.textContent = money(total);
      renderBoxes(stage, boxes, coverage, needed);
    }

    [m2Input, coverageInput, priceInput].forEach(function (input) {
      input.addEventListener('input', update);
      input.addEventListener('change', update);
    });
    wastageCheck.addEventListener('change', update);
    update();
  }

  function boot() {
    document.querySelectorAll('[data-tt-area-guide]').forEach(initGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
